export const SliderData04 = [
  {
    image: require("../../images/case_mp.png"),
  },
  {
    image: require("../../images/case_Mp_v2.png"),
  },
];
